import { render, staticRenderFns } from "./PublishingContractsSplitsEditPanel.vue?vue&type=template&id=eb2e311a"
import script from "./PublishingContractsSplitsEditPanel.vue?vue&type=script&lang=js"
export * from "./PublishingContractsSplitsEditPanel.vue?vue&type=script&lang=js"
import style0 from "./PublishingContractsSplitsEditPanel.vue?vue&type=style&index=0&id=eb2e311a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports